import { render, staticRenderFns } from "./UploadStudents.vue?vue&type=template&id=0ad6b2a6&"
import script from "./UploadStudents.vue?vue&type=script&lang=js&"
export * from "./UploadStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports